import React from "react";

const SocialAccountList = () => {
  return <div className="connectedAccounts_thead border-bottom">
      <div className="row m-0">
        {[
          { title: "Network", class: "col-3" },
          window.location.pathname.includes('connection') ? { title: "Account", class: "col-3" } : { title: "Account", class: "col-2" },
          { title: "Token Validity", class: "col-2" },
          { title: "Status", class: "col-2" },
          { title: "Refresh", class: "col-2" },
          !window.location.pathname.includes('connection') && { title: "Delete", class: "col-1 text-center" },
        ].map((item, index) => (

        <div className={item.class} key={index}>
          <span className="font-weight-bolder text-dark">{item.title}</span>
        </div>
        )) 
      }
      </div>
    </div>
};

export default SocialAccountList;
